import { Container, Row, Col, Accordion, Image } from "react-bootstrap";
import "./Questions.css";
import QuestionSingle from "./singleComponent/QuestionSingle";

const Questions = () => {
  return (
    <Container className="questions">
      <Row>
        <Col>
          <h1 className="questions-h1-mini">FAQ</h1>
          <h1 className="questions-h1">Wyjaśniamy</h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xxl={8} xl={8} lg={8} md={10} sm={12} xs={12}>
          <Accordion className="questions-accordion">
            <QuestionSingle
              question={
                "Jak zamówić legitymację ucznia lub służbową nauczyciela?"
              }
              answer={
                <ol>
                  <li>
                    Zarejestruj użytkownika za pomocą adresu mail podanego w
                    RSPO.
                    <br />
                    <a href="/">Rejestracja</a>
                  </li>
                  <li>Potwierdź adres mailowy.</li>
                  <li>Podaj dane szkoły.</li>
                  <li>Podpisz umowę.</li>
                  <li>Zrób zamówienie.</li>
                  Szczegóły w zakładce <a href="/offer">oferta</a>
                </ol>
              }
              id="0"
            />
            <QuestionSingle
              question={
                "Jaki format zdjęcia należy dostarczyć do e-legitymacji ucznia i legitymacji służbowej nauczyciela?"
              }
              answer={
                <>
                  <h3>Informacje ogólne</h3>
                  <ol>
                    <li>
                      Zdjęcie powinno być aktualne – zrób je nie wcześniej niż 6
                      miesięcy przed złożeniem wniosku,
                    </li>
                    <li>
                      Na zdjęciu nie możesz mieć nakrycia głowy, okularów z
                      ciemnymi szkłami ani innych rzeczy, które utrudniają
                      rozpoznanie,
                    </li>
                    <li>
                      Zdjęcie powinno przedstawiać całą głowę (od jej czubka)
                      oraz górną część barków,
                    </li>
                    <li>Twarz powinna zajmować 70-80% zdjęcia,</li>
                    <li>
                      Osoba fotografowana musi mieć naturalny wygląd twarzy (bez
                      żadnych gestów mimicznych), z zamkniętymi ustami.
                    </li>
                  </ol>
                  <h3>Wytyczne techniczne dotyczące zdjęcia</h3>
                  <ol>
                    <li>
                      Zdjęcie musi kolorowe w formie elektronicznej o:
                      <ul>
                        <li>
                          rozdzielczości minimalnej 492 x 633 piksele wielkości
                          maksymalnej do 2,5 MB,
                        </li>
                        <li>
                          tak, aby fotografia zachowywała proporcje
                          odpowiadające fotografii o wymiarach 35 x 45 mm
                          (szerokość x wysokość),
                        </li>
                      </ul>
                    </li>
                    <li>
                      Przykład prawidłowo zrobionego zdjęcia do legitymacji:
                      <Container className="mb-3 mt-3">
                        <Row>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_1.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_2.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_3.jpg"
                            />
                          </Col>
                        </Row>
                      </Container>
                    </li>
                    <li>
                      Przykład błędnie zrobionego zdjęcia do legitymacji:
                      <Container className="mb-3 mt-3">
                        <Row>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_4.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_5.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_6.jpg"
                            />
                          </Col>
                        </Row>
                      </Container>
                      <Container className="mb-3 mt-3">
                        <Row>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_7.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_8.jpg"
                            />
                          </Col>
                          <Col>
                            <Image
                              className="img-thumbnail"
                              src="./images/img_example_9.jpg"
                            />
                          </Col>
                        </Row>
                      </Container>
                    </li>
                  </ol>
                </>
              }
              id="1"
            />
            <QuestionSingle
              question={
                "Jakie dane należy podać przy zamówieniu legitymacji służbowej nauczyciela?"
              }
              answer={
                <ol>
                  <li>
                    Numer legitymacji w formacie NNNN RRRR, np. 0002 2025.
                  </li>
                  <li>Imię lub imiona nauczyciela.</li>
                  <li>Nazwisko nauczyciela.</li>
                  <li>Data wydania legitymacji służbowej nauczyciela.</li>
                  <li>Nazwa i adres szkoły w 4 wierszach po 30 znaków.</li>
                </ol>
              }
              id="3"
            />
            <QuestionSingle
              question={
                "Czy można zamówić duplikat legitymacji ucznia lub służbowej nauczyciela?"
              }
              answer={
                <ol>
                  <li>
                    Tak, można zamówić duplikat legitymacji ucznia lub służbowej
                    nauczyciela.
                  </li>
                  <li>
                    W tym celu należy złożyć zamówienie na duplikat legitymacji
                    w systemie.
                  </li>
                  <li>
                    Koszt duplikatu legitymacji ucznia lub służbowej nauczyciela
                    jest taki sam jak zwykłej legitymacji.
                  </li>
                </ol>
              }
              id="4"
            />
            <QuestionSingle
              question={
                "W jaki sposób przykleić hologram do legitymacji ucznia lub służbowej nauczyciela?"
              }
              answer={
                <ol>
                  <h4>Instrukcja przyklejania hologramów do legitymacji.</h4>
                  <li>
                    Przygotowanie miejsca pracy
                    <ul>
                      <li>
                        Upewnij się, że powierzchnia, na której będziesz
                        pracować, jest czysta i sucha.
                      </li>
                      <li>
                        Przygotuj legitymację oraz hologram do przyklejenia.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Przygotowanie legitymacji
                    <ul>
                      <li>
                        Oczyść powierzchnię legitymacji w miejscu, gdzie będzie
                        przyklejony hologram (np. miękką, niestrzępiącą się
                        ściereczką).
                      </li>
                      <li>
                        Upewnij się, że miejsce naklejenia jest suche i nie ma
                        na nim kurzu ani tłuszczu.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Naklejanie hologramu
                    <ul>
                      <li>
                        Delikatnie oddziel hologram od podkładki, trzymając za
                        krawędzie, aby nie dotknąć powierzchni klejącej.
                      </li>
                      <li>
                        Ostrożnie umieść hologram w wyznaczonym miejscu na
                        legitymacji (zgodnie z wyznaczonym miejscem na
                        legitymacji).
                      </li>
                    </ul>
                  </li>
                </ol>
              }
              id="5"
            />
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default Questions;
